import { useContext,useEffect, useState } from 'react'

import { fetchAccountContactActivity } from 'api'
import { ALL_ACTIVITY_TYPES } from 'context/filtersContext'
import { SortContext } from 'context/sortContext'
import { ContactType,ContactWithActivites } from 'modules/accountActivity/domain'

export const useAccountContactActivity = (
  accountId: string
): {
  response: ContactWithActivites[] | undefined
  accountContactsError: Error | unknown
  isLoadingAccountContacts: boolean
} => {
  const [response, setResponse] = useState<ContactWithActivites[]>()
  const [accountContactsError, setError] = useState<Error | unknown>(undefined)
  const [isLoadingAccountContacts, setIsLoading] = useState(false)

  const { contactsSort, contactsDescending } = useContext(SortContext)

  useEffect(() => {
    setIsLoading(true)
    setError(undefined)

    const cb = async () => {
      try {
        const { data } = await fetchAccountContactActivity({
          accountId,
          sortBy: contactsSort,
          descending: contactsDescending,
          selectedActivities: [...ALL_ACTIVITY_TYPES],
          selectedContactType: ContactType.ALL
        })
        setResponse(data)
      } catch (e) {
        setError(e)
      }
      setIsLoading(false)
    }

    cb()
    const interval = setInterval(cb, 1000 * 60 * 1)
    return () => clearInterval(interval)
  }, [accountId, contactsSort, contactsDescending])

  return { response, accountContactsError, isLoadingAccountContacts }
}
